<template>
  <div class="my-5">
    <Label>{{ label }}</Label>
    <textarea
      :name="name"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      class="mt-2 flex min-h-48 w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
    ></textarea>
  </div>
</template>

<script setup>
import { Label } from "@/components/ui/label";

defineProps({
  label: { type: String, required: true },
  name: { type: String, required: true },
  modelValue: { type: String, default: "" },
});

defineEmits(["update:modelValue"]);
</script>
